__webpack_require__.p = "https://gsesimulator.wassa-preprod.com/";